export default __webpack_public_path__ + "static/media/closet5-after3-2048w.2326665f.png";